import { LogLevels } from '../types/enums';

export function httpErrorLogLevel(status: number): LogLevels {
  return status >= 400 && status < 500 ? LogLevels.warning : LogLevels.error;
}
